<template>
  <div>
    <b-form>
      <b-container>
        <b-form-row v-for="(propChunk,index) in simplePropChunks" :key="index" cols="2">
          <b-col v-for="prop in propChunk"
                 v-bind:key="prop.definition.name">
            <b-form-group
              :id="prop.definition.name"
              :label="prop.definition.title  ? prop.definition.title : prop.definition.name"
              :label-for="prop.definition.name"
              :description="prop.definition.description ? prop.definition.description : 'No description'"
            >
              <Component :is="prop.component" v-bind="{ prop: prop }"/>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row v-for="(propChunk,index) in complexPropChunks" :key="'complex' + index" cols="2">
          <b-col v-for="prop in propChunk"
                 v-bind:key="prop.definition.name">
            <b-form-group
              :id="prop.definition.name"
              :label="prop.definition.title"
              :label-for="prop.definition.name"
              :description="prop.definition.description"
            >
              <Component :is="prop.component" v-bind="{ prop: prop, schema: schema }"/>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>

import _ from 'lodash'
import RefInput from './RefInput'
// eslint-disable-next-line no-unused-vars
import TextInput from './TextInput'
import CheckBoxInput from './CheckBoxInput'
// eslint-disable-next-line no-unused-vars
import EnumInput from './EnumInput'

export default {
  name: 'EditItem',
  components: {TextInput, CheckBoxInput, RefInput, EnumInput},
  props: ['simpleProperties', 'complexProperties', 'schema'],
  data () {
    return {
    }
  },
  computed: {
    simplePropChunks () {
      return _.chunk(Object.values(this.simpleProperties), 2)
    },
    complexPropChunks () {
      if (this.complexProperties) {
        return _.chunk(Object.values(this.complexProperties), 2)
      } else {
        return []
      }
    }
  },
  mounted () {
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/editor/EditItem.vue